import { createContext, useContext } from "react";

export const DEFAULT_FEATURE_FLAGS = {
  codEnabled: true,
  razorpayEnabled: true,
  wishlistEnabled: true,
  googleLoginUserEnabled: true,
  googleLoginVendorEnabled: true,
};

export const FeatureFlagsContext = createContext(DEFAULT_FEATURE_FLAGS);

export function useFeatureFlags() {
  return useContext(FeatureFlagsContext);
}
